<template>
    <div class="results">
        <div class="results__top">
            <div class="results__title">
                <h2>{{ getTranslatedText("Results") }}</h2>
            </div>
            <div class="results__select">
                <div class="results__select--game">
                    <span>{{ getTranslatedText("Select Game") }}</span>
                    <Select
                      v-model="selectGame"
                      :items="itemsGame"
                    />
                </div>
                <div class="results__select--date">
                    <span>{{ getTranslatedText("Select Draw") }}</span>
                    <v-combobox
                        variant="outlined"
                        v-model="selectDate"
                        :items="itemsDate"
                        item-text="name"
                        @input.native="handleComboboxInput"
                        @change="handleValueChange"
                    />
                </div>
            </div>
            <div class="results__logo">
                <img v-if="selectGame === itemsGame[1]" src="~ThemePath/images/logo/loto_vert_color.png" alt="" />
                <img v-if="selectGame === itemsGame[0]" src="~ThemePath/images/logo/loto_color.png" alt="" />
                <img v-if="selectGame === itemsGame[2]" src="~ThemePath/images/logo/loto_plus_color.png" alt="" />
            </div>
        </div>

        <div class="results__content">
            <Loading v-if="isLoadingScreen"/>
            <div class="results__content--wrap" v-else-if="dataResults.length !== 0 && !isLoadingScreen">
                <template v-for="(item, index) in dataResults">
                    <div class="results__content--item" :key="index">
                        <p>{{ getTranslatedText(item.name) }}</p>
                        <p>
                          <ul>
                              <li v-for="(number, i) in item.results[0]" :key="i">{{ number }}</li>
                          </ul>
                          <ButtonCommon :isNoHover="true" text="Print"  @action-button="onPrintClicked(item)"/>
                        </p>
                    </div>
                </template>
            </div>
            <div class="results__content--empty" v-else>
              <p>{{ getTranslatedText('your results is empty') }}</p>
            </div>
        </div>
        <div class="results__list_page">
          <Pagination :totalPages="total_page" :currentPage="current_page" @page-change="handlePageChange"></Pagination>
        </div>
    </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import errorDeviceMinxins from "@/mixins/errorDevice/errorDevice-mixins";
import printMixins from "@/mixins/print/print-mixins";
import configGameMinxins from "@/mixins/configGame/configGame-mixins";
import ButtonCommon from "@/components/common/button";
import ResultsService from "@/services/result.service";
import Pagination from "@/components/common/pagination";
import Select from '@/components/common/select';
import Loading from "@/components/common/loading";
const GAMES_SLUG = process.env.VUE_APP_ENABLE_GAMES_SLUG;

export default {
  mixins: [languageMixins, errorDeviceMinxins, printMixins, configGameMinxins],
  components: {
    ButtonCommon,
    Pagination,
    Select,
    Loading
  },
  data() {
    return {
      selectGame:"",
      dataSearch: "",
      itemsGame: [],
      selectDate: "",
      typeGame: "",
      itemsDate: [],
      dataResults: [],
      mainDataResults: [],
      current_page: 1,
      total_page: 0,
      per_page: 10,
      printData: null,
      isLoadingScreen: false,
    };
  },
  created() {
    this.selectGame = this.configGame[0].name ? this.configGame[0].name : "Loto Hotpicks"
      this.configGame.forEach((item, id) => {
        this.itemsGame.push(item?.name ? item.name : this.getTranslatedText(GAMES_SLUG.split(",")[id]))
      })
    this.typeGame = this.slugGames[0]
    this.fetchResults();
  },
  watch: {
    selectGame() {
      if (this.selectGame === this.itemsGame[0]) {
        this.typeGame = this.slugGames[0];
        this.imgUrlsPrint = [
          require('ThemePath/img/print/logo-loto-hotpicks.jpg'),
          require('ThemePath/img/print/logo-loto-hotpicks-2x.jpg')
        ]
      } else if (this.selectGame === this.itemsGame[1]) {
        this.typeGame = this.slugGames[1];
        this.imgUrlsPrint = [
          require('ThemePath/img/print/logo-loto-vert-hotpicks.jpg'),
          require('ThemePath/img/print/logo-loto-vert-hotpicks-2x.jpg')
        ]
      } else if (this.selectGame === this.itemsGame[2]) {
        this.typeGame = this.slugGames[2];
        this.imgUrlsPrint = [
          require('ThemePath/img/print/logo-loto-plus-hotpicks.jpg'),
          require('ThemePath/img/print/logo-loto-plus-hotpicks-2x.jpg')
        ]
      }
      this.selectDate = "";
      this.printData = null;
      this.current_page = 1;
      this.fetchResults();
    },
    selectDate: {
      handler() {
        this.dataResults = this.mainDataResults.filter(
          (e) => e.event_id === this.selectDate?.id
        );
      },
    deep: true,
  },
    current_page() {
      this.fetchResults();
    },
  },
  methods: {
    handleComboboxInput(value){
      this.fetchResults(value.target.value)
    },
    handleValueChange() {
      setTimeout(() => {
        document.activeElement.blur();
      }, 100);
    },
    async fetchResults(searchValue) {
      try {
        if(!searchValue){
          this.isLoadingScreen = true;
        }
        const res = await ResultsService.getResults(
          this.current_page,
          this.per_page,
          this.typeGame,
          searchValue
        );
        if (res.status === "success") {
          this.itemsDate = [];
          if(!searchValue){
            this.dataResults = res.data.entries;
          }
          this.mainDataResults = res.data.entries;
          res.data.entries.forEach((item) => {
            this.itemsDate.push({
              name: item.name,
              id: item.event_id,
            });
          });
          this.total_page = Math.ceil(res.data.total / this.per_page);
        } else {
          console.log(res);
        }
        this.isLoadingScreen = false;
        this.checkErrorDevice(this.$router, res)
      } catch (error) {
        console.log(error);
        this.isLoadingScreen = false;
        this.checkErrorDevice(this.$router, error)
      }
    },
    handlePageChange(page) {
      this.current_page = page;
      this.selectDate = null;
    },
    async onPrintClicked(item) {
      // if(!this.printData) return

      this.printData = {
        game: this.selectGame,
        gameSlug: item?.game_slug,
        results: item?.results,
        name: item?.name,
        drawText: '1st NUMBER DRAWN',
        base64logos: {},
      }
        
      // print only, missing other UI/UX flow
      this.printData.base64logos = {
        "logo58": await this.getImgBase64(this.imgUrlsPrint[0]),
        "logo": await this.getImgBase64(this.imgUrlsPrint[1])
      }
      parent.postMessage({ command: 'print-result', data: this.printData, defaultSunmiFont: this.$store.state.configAccount?.sunmiPrinterFont }, '*')
    },
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/results/_index.scss";
</style>
